import { Injectable } from '@angular/core';
import { CALENDAR_LOCALES } from './calendar-locales';
import { LOCALE_TITLES } from './locale-titles';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor() { }

  setCalendarLanguage(localeId: string){
    let locale = CALENDAR_LOCALES.fr;
    if(localeId == "nl"){
      locale = CALENDAR_LOCALES.nl;
    }
    if(localeId == "fr"){
      locale = CALENDAR_LOCALES.fr;
    }
    if(localeId == "en"){
      locale = CALENDAR_LOCALES.en;
    }
    if(localeId == "es"){
      locale = CALENDAR_LOCALES.es;
    }
    return locale;
  }

  setTitleLanguage(localeId: string){
    let title = LOCALE_TITLES.fr;
    if(localeId == "nl"){
      title = LOCALE_TITLES.nl;
    }
    if(localeId == "fr"){
      title = LOCALE_TITLES.fr;
    }
    if(localeId == "en"){
      title = LOCALE_TITLES.en;
    }
    if(localeId == "es"){
      title = LOCALE_TITLES.es;
    }
    return title;
  }
}
